export default "__VITE_ASSET__BUJPBOrB__"